import React from "react";

export function PreviewIcon() {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1332_505)">
        <path
          d="M43.5417 6.875H11.4583C8.91458 6.875 6.875 8.9375 6.875 11.4583V43.5417C6.875 46.0625 8.91458 48.125 11.4583 48.125H43.5417C46.0625 48.125 48.125 46.0625 48.125 43.5417V11.4583C48.125 8.9375 46.0854 6.875 43.5417 6.875ZM43.5417 43.5417H11.4583V16.0417H43.5417V43.5417ZM30.9375 29.7917C30.9375 31.6938 29.4021 33.2292 27.5 33.2292C25.5979 33.2292 24.0625 31.6938 24.0625 29.7917C24.0625 27.8896 25.5979 26.3542 27.5 26.3542C29.4021 26.3542 30.9375 27.8896 30.9375 29.7917ZM27.5 20.625C21.2438 20.625 15.9042 24.4292 13.75 29.7917C15.9042 35.1542 21.2438 38.9583 27.5 38.9583C33.7563 38.9583 39.0958 35.1542 41.25 29.7917C39.0958 24.4292 33.7563 20.625 27.5 20.625ZM27.5 35.5208C24.3375 35.5208 21.7708 32.9542 21.7708 29.7917C21.7708 26.6292 24.3375 24.0625 27.5 24.0625C30.6625 24.0625 33.2292 26.6292 33.2292 29.7917C33.2292 32.9542 30.6625 35.5208 27.5 35.5208Z"
          fill="white"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1332_505">
          <rect width="55" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
